import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.5rem;
  background-color: white;
  border-radius: 0.375rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0 3px 9px 0;

  h2 {
    margin-block: 0 1rem;
  }
`;

export const Rankings = styled.ul`
  li {
    background: white;
    padding: 0.25rem 1rem;
    border-radius: 0.5rem;
    margin-bottom: 0.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.125em;
    border: 1px solid;
    font-weight: 500;

    &:first-child {
      font-size: 1.85em;
      font-weight: bold;
      border: 4px solid gold;
      background-color: #fffad7;
      margin-bottom: 0.4rem;
    }

    &:nth-child(2),
    &:nth-child(3) {
      font-size: 1.5em;
      font-weight: bold;
      margin-bottom: 0.25rem;
      border: 3px solid silver;
      background-color: whitesmoke;
    }

    &:nth-child(3) {
      border: 3px solid #cf8134;
      background-color: #ffecd8;
    }
  }
`;

export const Points = styled.div`
  border: 2px solid #b673f9;
  background-color: #cbb1ff;
  border-radius: 16px;
  padding: 0.25rem 0.5rem;
  font-size: 0.6em;
  font-weight: bold;
`;
